import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type ViewMoreCTAClasses = 'cta' | 'label' | 'container';

const viewMoreCTAStyles = makeStyles<ISpcTheme, ViewMoreCTAClasses>(
  () => ({
    container: {
      display: 'flex',
      justifyContent: 'center',
    },
    cta: {
      textDecoration: 'underline',
      display: 'flex',
      alignItems: 'center',
    },
    label: {},
  }),
  { name: 'Common_ViewMoreCTA' },
);

export default viewMoreCTAStyles;
